import React from 'react';
import PropTypes from 'prop-types';
import Reveal from 'react-reveal/Reveal';
import Responsive from 'react-responsive';
import './MediaRowCustomizable.scss';

const propTypes = {
    textBoxPosition: PropTypes.string,
    img: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.object,
    label: PropTypes.string,
    ctaroute: PropTypes.string,
    ctalabel: PropTypes.string,
    textBoxType: PropTypes.string,
    textBoxWidth: PropTypes.number,
    screenWidth: PropTypes.number,
    LeftPositionMargin: PropTypes.number,
    RightPositionMargin: PropTypes.number,
    LeftPositionHotZoneMargin: PropTypes.number,
    RightPositionHotZoneMargin: PropTypes.number,
    positionX: PropTypes.number,
    positionY: PropTypes.number,
    imagePositionStyle: PropTypes.string,
    hasAnim: PropTypes.string,
    imgOpt: PropTypes.string,
    lableWidth: PropTypes.number,

};

export default class MediaRowCustomizable extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const Desktop = props => <Responsive {...props} minWidth={1199} />;
        const DesktopSm = props => <Responsive {...props} minWidth={1025} maxWidth={1198} />;
        const Mobile = props => <Responsive {...props} maxWidth={1024} />;

        let isSafari = window.safari !== undefined;

        const {textBoxPosition, img, imagePositionStyle, imgOpt, hasAmin, label, title, content, ctaroute, ctalabel, textBoxType, textBoxWidth, screenWidth, LeftPositionHotZoneMargin, RightPositionHotZoneMargin, LeftPositionMargin, RightPositionMargin, positionX, positionY, lableWidth} = this.props;

        let ctaBox = textBoxType === 'ctaBox';
        let textBox = textBoxType === 'textBox';

        const cta = (
            <a className='media-row-cta' href={ctaroute}>{ctalabel} </a>
        );

        const LeftPositionBoxStyle = {
            width: `${textBoxWidth}px`,
            marginLeft: `${LeftPositionMargin}%`,
            marginRight: `${100 - Math.ceil((LeftPositionHotZoneMargin+20)/screenWidth*100)}%`,
        };

        //console.log('overlay left', LeftPositionBoxStyle);


        const RightPositionBoxStyle = {
            width: `${textBoxWidth}px`,
            marginLeft: `${100 - Math.ceil((RightPositionHotZoneMargin+20)/screenWidth*100)}%`,
            marginRight: `${RightPositionMargin}%`,
        };

        const MobileLableStyle = {
            maxWidth: `${lableWidth}px`,
        }

        //console.log('overlay right', RightPositionBoxStyle);

        const imgStyle = {
            background: `url(${img})`,
            backgroundPosition: `${positionX}% ${positionY}%`,
        };
        const imgCover = {
            background: `url(${img})`,
            backgroundSize: 'cover',
        };


       const boxWidth = Math.floor(textBoxWidth/screenWidth*100);
       const leftHotZoneP = 100 - Math.ceil((LeftPositionHotZoneMargin+20)/screenWidth*100);
       const rightHotZoneP = 100 - Math.ceil((RightPositionHotZoneMargin+20)/screenWidth*100);

       if(LeftPositionMargin + boxWidth + leftHotZoneP > 100) {
           console.log('Error, left box overlap!');
       }
        if(RightPositionMargin + boxWidth + rightHotZoneP > 100) {
            console.log('Error, right box overlap!');
        }

        let left = textBoxPosition === 'left';
        let right = textBoxPosition === 'right';


        return (
            <div>
                {textBox &&
                <div>
                    <Desktop>
                        <div className='meadia-row-custom-holder'>
                            {this.props.rotator}
                            <img src={img} className={`media-img ${imgOpt}`}/>
                            {left &&
                            <Reveal effect='fadeInUp' duration={1000} fraction={0.01}>
                                <div className={`full-bleed-copy left`} style={LeftPositionBoxStyle}>
                                    <p className={isSafari === false ? "full-bleed-title typ--t2" : "full-bleed-title-safari typ--t2"}>{title}</p>
                                    <div className="full-bleed-hrdiv"></div>
                                    <h2 className="full-bleed-label ">{label}</h2>
                                    {content}
                                    <div className='cta-holder'>
                                        {ctaroute && cta}
                                    </div>
                                </div>
                            </Reveal>
                            }
                            {right &&
                            <Reveal effect='fadeInUp' duration={1000} fraction={0.01}>
                                <div className={`full-bleed-copy right`} style={RightPositionBoxStyle}>
                                    <p className={isSafari === false ? "full-bleed-title typ--t2" : "full-bleed-title-safari typ--t2"}>{title}</p>
                                    <div className="full-bleed-hrdiv"></div>
                                    <h2 className="full-bleed-label ">{label}</h2>
                                    {content}
                                    <div className='cta-holder'>
                                        {ctaroute && cta}
                                    </div>
                                </div>
                            </Reveal>
                            }
                        </div>
                    </Desktop>
                    <DesktopSm>
                        <div className='meadia-row-custom-holder-medium'>
                            {this.props.rotator}
                            <div>
                                {this.props.hasAnim === 'rotator' ?
                                    <img src={img} className='media-img'/> :
                                    <div className='image-wrapper' style={imagePositionStyle === 'reposition' ? imgStyle : imgCover}/>
                                }
                            </div>
                            {left &&
                            <Reveal effect='fadeInUp' duration={1000} fraction={0.01}>
                                <div className={`full-bleed-copy `} style={LeftPositionBoxStyle}>
                                    <p className={isSafari === false ? "full-bleed-title typ--t2" : "full-bleed-title-safari typ--t2"}>{title}</p>
                                    <div className="full-bleed-hrdiv"></div>
                                    <h2 className="full-bleed-label ">{label}</h2>
                                    {content}
                                    <div className='cta-holder'>
                                        {ctaroute && cta}
                                    </div>
                                </div>
                            </Reveal>
                            }
                            {right &&
                            <Reveal effect='fadeInUp' duration={1000} fraction={0.01}>
                                <div className={`full-bleed-copy `} style={RightPositionBoxStyle}>
                                    <p className={isSafari === false ? "full-bleed-title typ--t2" : "full-bleed-title-safari typ--t2"}>{title}</p>
                                    <div className="full-bleed-hrdiv"></div>
                                    <h2 className="full-bleed-label ">{label}</h2>
                                    {content}
                                    <div className='cta-holder'>
                                        {ctaroute && cta}
                                    </div>
                                </div>
                            </Reveal>
                            }
                        </div>

                    </DesktopSm>

                    <Mobile>
                        <div className='mobile-meadia-row-custom-holder'>
                            {this.props.rotator}
                            <img src={img} className='media-img'/>
                            <div className="full-bleed-copy-mobile ">
                                <p className={isSafari === false ? "full-bleed-title typ--t2" : "full-bleed-title-safari typ--t2"}>{title}</p>
                                <div className="full-bleed-hrdiv"></div>
                                <h2 className="full-bleed-label " style={MobileLableStyle} >{label}</h2>
                                {content}
                                <div className='cta-holder'>
                                    {ctaroute && cta}
                                </div>
                            </div>
                        </div>
                    </Mobile>
                </div>
                }
                {ctaBox &&
                <div>
                    <Desktop>
                        <div className='meadia-row-custom-holder'>
                            <img src={img} className='media-img'/>
                            {left &&
                            <Reveal effect='fadeInUp' duration={1000} fraction={0.01}>
                                <div className={`full-bleed-copy left`} style={LeftPositionBoxStyle}>
                                    <h2 className="full-bleed-label ">{label}</h2>
                                    <div className="full-bleed-hrdiv"></div>
                                    {content}
                                    <div className='cta-holder'>
                                        {ctaroute && cta}
                                    </div>
                                </div>
                            </Reveal>
                            }
                            {right &&
                            <Reveal effect='fadeInUp' duration={1000} fraction={0.01}>
                                <div className={`full-bleed-copy right`} style={RightPositionBoxStyle}>
                                    <h2 className="full-bleed-label ">{label}</h2>
                                    <div className="full-bleed-hrdiv"></div>
                                    {content}
                                    <div className='cta-holder'>
                                        {ctaroute && cta}
                                    </div>
                                </div>
                            </Reveal>
                            }
                        </div>
                    </Desktop>
                    <DesktopSm>
                        <div className='meadia-row-custom-holder-medium'>
                            <div className='image-wrapper' style={imagePositionStyle === 'reposition' ? imgStyle : imgCover}/>
                            {left &&
                            <Reveal effect='fadeInUp' duration={1000} fraction={0.01}>
                                <div className={`full-bleed-copy `} style={LeftPositionBoxStyle}>
                                    <h2 className="full-bleed-label ">{label}</h2>
                                    <div className="full-bleed-hrdiv"></div>
                                    {content}
                                    <div className='cta-holder'>
                                        {ctaroute && cta}
                                    </div>
                                </div>
                            </Reveal>
                            }
                            {right &&
                            <Reveal effect='fadeInUp' duration={1000} fraction={0.01}>
                                <div className={`full-bleed-copy `} style={RightPositionBoxStyle}>
                                    <h2 className="full-bleed-label ">{label}</h2>
                                    <div className="full-bleed-hrdiv"></div>
                                    {content}
                                    <div className='cta-holder'>
                                        {ctaroute && cta}
                                    </div>
                                </div>
                            </Reveal>
                            }
                        </div>
                    </DesktopSm>

                    <Mobile>
                        <div className='mobile-meadia-row-custom-holder'>
                            <img src={img} className='media-img'/>
                            <div className="full-bleed-copy-mobile ">
                                <h2 className="full-bleed-label-cta " style={MobileLableStyle}>{label}</h2>
                                <div className="full-bleed-hrdiv"></div>
                                {content}
                                <div className='cta-holder'>
                                    {ctaroute && cta}
                                </div>
                            </div>
                        </div>
                    </Mobile>
                </div>
                }
            </div>
        )
    }
}



MediaRowCustomizable.propTypes = propTypes;

MediaRowCustomizable.defaultProps = {
    textBoxType: 'textBox',
    img: null,
    imgxs: null,
    title: null,
    content: null,
    label: null,
    ctaroute: null,
    ctalabel: null,
    screenWidth: 2800,
};



// WEBPACK FOOTER //
// ./src/components/MediaRowCustomizable/index.js